var o = function o(_o) {
  return _o.scrollTop;
};
export { o as forceReflow };